export default __webpack_public_path__ + "static/media/hats.78889842.jpg";